import React, { FC } from "react";
import { Formik } from "formik";
import { BodyWrapper, ErrorMessage, InputWrapper, ModalButtonsWrapper, ButtonWrapper } from "./elements";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { Button } from "../../atoms/Button";
import { Loader } from "../../atoms/Loader";

type Props = {
  onConfirm: (values: any) => void;
  onCancel: () => void;
  validate: any;
  isLoading: boolean;
  invalidOldPassword?: any;
};

const ChangePasswordModalBody: FC<Props> = ({
  onConfirm,
  onCancel,
  validate,
  isLoading,
  invalidOldPassword = null,
}) => {

  return (
    <Formik
    onSubmit={onConfirm}
    initialValues={{ password: "", new_password: "", confirm_password: "" }}
    validate={validate}
  >
    {({ values, handleChange, handleSubmit, errors }) => ( 
      <form onSubmit={handleSubmit}>
        <InputWrapper>
          <InputWithLabel
            name="password"
            onChange={handleChange("password")}
            value={values.password}
            label={"Old Password"}
            type={"password"}
          />
          {invalidOldPassword && (
            <ErrorMessage>Old Password does not match</ErrorMessage>
          )}
        </InputWrapper>
        <InputWrapper>
          <InputWithLabel
            name="new_password"
            onChange={handleChange("new_password")}
            value={values.new_password}
            label={"New Password"}
            type={"password"}
          />
          {errors.new_password && (
            <ErrorMessage>{errors.new_password}</ErrorMessage>
          )}
        </InputWrapper>
        <InputWrapper>
          <InputWithLabel
            name="confirm_password"
            onChange={handleChange("confirm_password")}
            value={values.confirm_password}
            label={"Re-enter New Password"}
            type={"password"}
          />
          {errors.confirm_password && (
            <ErrorMessage>{errors.confirm_password}</ErrorMessage>
          )}
        </InputWrapper>
        <span style={{ color: "#E15126" }}>You will be automatically logged out when you change your password.</span>
        <BodyWrapper>
          <ModalButtonsWrapper>
            <Button type="primary" id="cancel_btn" onClick={onCancel}>
              Cancel
            </Button>
            {isLoading ? (
              <ButtonWrapper>
                <Loader />
              </ButtonWrapper>
            ) : (
              <Button type="primary" htmlType={"submit"}>
                Change
              </Button>
            )}
          </ModalButtonsWrapper>
        </BodyWrapper>
      </form>
    )}
    </Formik>
  );
};

export default ChangePasswordModalBody;
